import useIsBottomNavigation from '~/client/hooks/useIsBottomNavigation';
import useSite from '~/client/hooks/useSite';
import useMyLoyaltyStatusSidebar from '../../hooks/useMyLoyaltyStatusSidebar';

const useLoyaltyControl = () => {
  const { site, isSportsbet } = useSite();
  const { myStatus } = useMyLoyaltyStatusSidebar();
  const tierImgUrl = myStatus?.currentTier?.logoUrl?.replace(
    'small.png',
    'avatar.png',
  );
  const progress = myStatus?.nextMilestone?.progress || 0;
  const isBottomNavigation = useIsBottomNavigation();
  const loyaltyLink = '/profile/loyalty';
  const clubhouseLink = '/user/clubhouse';
  const hrefLink = isSportsbet ? clubhouseLink : loyaltyLink;

  return { isSmall: isBottomNavigation, hrefLink, progress, site, tierImgUrl };
};

export default useLoyaltyControl;
